import {SimpleQueryFiltersResource} from './simpleQueryFiltersResource.model';
import {SimpleEventsQueryResource} from './simpleEventsQueryResource.model';

export class SimplePaginatedEventsQueryResource {
    page: number;
    countPerPage: number;
    sortFieldName: string;
    sortType: string;
    eventsQueryResource: SimpleEventsQueryResource;

    constructor(simplePaginatedEventsQueryResource: SimplePaginatedEventsQueryResource = {} as SimplePaginatedEventsQueryResource) {
        this.page = simplePaginatedEventsQueryResource.page || null;
        this.countPerPage = simplePaginatedEventsQueryResource.countPerPage || null;
        this.eventsQueryResource = simplePaginatedEventsQueryResource.eventsQueryResource || null;
        this.sortFieldName = simplePaginatedEventsQueryResource.sortFieldName || null;
        this.sortType = simplePaginatedEventsQueryResource.sortType || null;
    }
}
